/**
 * Application hostname constants for different environments
 */
export const AppHostName = {
  Fed: {
    PPE: 'mem.azure.us',
    Prod: 'mem.microsoftfederal.com',
    // localhost: 'localhost', // enable for local Fed testing
  },
} as const;

/**
 * Custom hook to determine if the current environment is a Federal environment
 * @returns {boolean} True if the current hostname is a Federal environment, false otherwise
 */
export const useIsFed = (): boolean => {
  // Handle cases where window.location might not be available (SSR, tests, etc.)
  if (typeof window === 'undefined' || !window.location) {
    return false;
  }

  const { hostname } = window.location;

  // Handle null, undefined, or empty hostname
  if (!hostname || typeof hostname !== 'string') {
    return false;
  }

  // Check if hostname exactly matches any of the Fed hostnames
  const fedHostnames = Object.values(AppHostName.Fed);
  const isFedHostname = fedHostnames.includes(hostname as any);

  return isFedHostname;
};
